import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal } from '../../actions/close-modal';
import DemoteModeratorModal from '../../components/demote-moderator-modal';
import { getUserById } from '../../selectors/user-selectors';
import { getUserById as getMemberById } from '../../selectors/search-selectors';

const mapStateToProps = (state, ownProps) => ({
  user: getUserById(state, ownProps.userId) || getMemberById(state, ownProps.userId),
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      demoteModerator: () => closeModal(ownProps.userId),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DemoteModeratorModal);



// WEBPACK FOOTER //
// ./app/containers/demote-moderator-modal/demote-moderator-modal.js